module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-12-db202e439c2a16926cd17c7064446b56.jpg";